import { AltLayout as EnAltLayout } from "@enpowered/ui";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { UserContext } from "../../../auth/contexts/user";
import { getMicrofrontendManifests } from "../../../services/microfrontends.service";
import { useLogout } from "../../../lib/use-logout";
import { useSideNavItems } from "../../../hooks/use-sidenav-items.hook";
import { useAbsolutePath } from "../../../hooks/use-absolute-path.hook";

/**
 *
 * @param {object} props
 * @param {string} props.pageTitle
 * @param {any} props.children
 * @param {boolean} props.noSidebar
 * @param {() => Promise<import("@enpowered/microfrontends").MicroFrontendManifest[]>} [props.getMicrofrontendManifests]
 * @returns
 */
export const AltLayout = ({
  pageTitle,
  children,
  noSidebar,
  getMicrofrontendManifests
}) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const logout = useLogout();

  const getAbsolutePath = useAbsolutePath();

  const isUrlActive = url => {
    return window.location.pathname === getAbsolutePath(url);
  };
  const sideNavItems = useSideNavItems({ user, getMicrofrontendManifests });
  return (
    <EnAltLayout
      pageTitle={pageTitle}
      logout={logout}
      userName={`${user?.firstName || user?.email}`}
      isUrlActive={isUrlActive}
      Link={({ to, children, ...props }) => (
        <a
          href={to}
          onClick={e => {
            e.preventDefault();
            navigate(to);
          }}
          {...props}
        >
          {children}
        </a>
      )}
      // @ts-ignore
      items={noSidebar ? [] : sideNavItems}
    >
      {children}
    </EnAltLayout>
  );
};

AltLayout.defaultProps = {
  getMicrofrontendManifests
};
